import { memo } from 'react';
import { useIntl } from 'react-intl';

export const OPEN_IN_NEW_WINDOW = 'open-in-new-window';
export const TINDER_BRAND = 'tinder-brand';

const GlobalDescription = () => {
  const { formatMessage } = useIntl();

  return (
    <div className="Hidden Cntv(h)" data-nosnippet role="contentinfo">
      <span id={TINDER_BRAND}>{formatMessage({ id: 'tinder' })}</span>
      <span id={OPEN_IN_NEW_WINDOW}>{formatMessage({ id: 'a11yLinkInNewWindow' })}</span>
    </div>
  );
};

export default memo(GlobalDescription);
